import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ForeignLanguange  {
    _originalTypeClassName = "zERP.BO.ForeignLanguange";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ForeignLanguange.translate = translateService;
}
this.Id = null;
this.Code = null;
this.DiplomaTitle = null;
this.CEFRLevel = null;
this.ObtainingDate = null;
this.ExpiredDate = null;
this.DiplomaLink = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.State = null;
this.HRComment = null;
this.EmpComment = null;
this.StatePrevious = null;
this.HRState = null;
this.IsHRAdd = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
DiplomaTitle:any;
CEFRLevel:any;
ObtainingDate:any;
ExpiredDate:any;
DiplomaLink:any;
DocumentType:any;
DocumentDescription:any;
State:any;
HRComment:any;
EmpComment:any;
StatePrevious:any;
HRState:any;
IsHRAdd:any;
Institution:any;
Employee:any;
Language:any;
Diploma:any;
static setInstitution = ($this, value) => {
var oldValue = $this.Institution;
$this.Institution = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeForeignLanguange(oldValue, $this);
}
Domain.Employee.addForeignLanguange(value, $this);
}
}
static setLanguage = ($this, value) => {
var oldValue = $this.Language;
$this.Language = value;
if (value != null) {
}
}
static setDiploma = ($this, value) => {
var oldValue = $this.Diploma;
$this.Diploma = value;
if (value != null) {
}
}

static GetClassName(): any{return "ForeignLanguange";
}
static ParseCEFRLevel(): any{let status = "";
return (status == "A1" ? Domain.CEFRLevel.A1 : ((status == "A2" ? Domain.CEFRLevel.A2 : ((status == "B1" ? Domain.CEFRLevel.B1 : ((status == "B2" ? Domain.CEFRLevel.B2 : ((status == "C1" ? Domain.CEFRLevel.C1 : Domain.CEFRLevel.C2)))))))));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}